function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 10 39 L 61 39 L 61 107 L 10 107 Z M 10 39 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 111.167969 56.503906 C 111.167969 84.378906 88.703125 106.972656 60.996094 106.972656 C 33.289062 106.972656 10.824219 84.378906 10.824219 56.503906 C 10.824219 28.628906 33.289062 6.03125 60.996094 6.03125 C 88.703125 6.03125 111.167969 28.628906 111.167969 56.503906 Z M 111.167969 56.503906 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 10 6 L 107 6 L 107 74 L 10 74 Z M 10 6 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 111.167969 56.503906 C 111.167969 84.378906 88.703125 106.972656 60.996094 106.972656 C 33.289062 106.972656 10.824219 84.378906 10.824219 56.503906 C 10.824219 28.628906 33.289062 6.03125 60.996094 6.03125 C 88.703125 6.03125 111.167969 28.628906 111.167969 56.503906 Z M 111.167969 56.503906 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 41 34 L 112 34 L 112 107 L 41 107 Z M 41 34 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 111.167969 56.503906 C 111.167969 84.378906 88.703125 106.972656 60.996094 106.972656 C 33.289062 106.972656 10.824219 84.378906 10.824219 56.503906 C 10.824219 28.628906 33.289062 6.03125 60.996094 6.03125 C 88.703125 6.03125 111.167969 28.628906 111.167969 56.503906 Z M 111.167969 56.503906 "
})));

function SvgBrowserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "45pt",
    height: "45pt",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.686275%,78.039216%,3.137255%)",
      fillOpacity: 1
    },
    d: "M 60.996094 39.347656 L 41.308594 73.652344 L 60.996094 106.972656 L 15.644531 119.847656 L -3.433594 67.132812 L 4.773438 39.347656 Z M 60.996094 39.347656 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.235294%,66.666667%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 80.691406 73.652344 L 106.105469 34.378906 L 106.105469 0.4375 L 37.375 -13.773438 L 4.773438 39.347656 L 60.996094 39.347656 Z M 80.691406 73.652344 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.882353%,19.215686%,19.215686%)",
      fillOpacity: 1
    },
    d: "M 106.105469 34.378906 L 80.691406 73.652344 L 41.308594 73.652344 L 61.003906 106.96875 L 70.707031 114.25 L 123.117188 96.757812 C 123.117188 96.757812 124.804688 52.832031 124.804688 52.929688 C 124.804688 53.027344 112.730469 34.371094 112.730469 34.371094 L 106.105469 34.371094 Z M 106.105469 34.378906 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 60.996094 39.347656 L 80.691406 73.652344 L 41.308594 73.652344 Z M 60.996094 39.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.019608%,60.392157%,80.784314%)",
      fillOpacity: 1
    },
    d: "M 61.003906 47.519531 L 48.007812 70.160156 L 73.992188 70.160156 Z M 61.003906 47.519531 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/browser_icon.3dc56cbc.svg";
export { ForwardRef as ReactComponent };